var render, staticRenderFns
import script from "./ArticleBody.vue?vue&type=script&lang=js&"
export * from "./ArticleBody.vue?vue&type=script&lang=js&"
import style0 from "./ArticleBody.vue?vue&type=style&index=0&id=34a5e1d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a5e1d2",
  null
  
)

export default component.exports